/* eslint-disable no-unused-vars */
import React from 'react';

import GetSellerConfig from '../../GetSellerConfig';

const OrnamentalDivider = () => {
    const {
        sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight,
    } = GetSellerConfig();

    return (
        <div>
            <div className="flex items-center gap-2 my-3 px-1">
                <div className="flex-1 h-px" style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
                <div
                    className="w-3 h-3 rotate-45 border-2"
                    style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark, backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                />
                <div className="flex-1 h-px" style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixMedium }} />
            </div>
        </div>
    );
};

export default OrnamentalDivider;
